export const ROOT = '/JobOffer';
export const EMAILPREVIEWROOT = '/EmailPreviewAPI';
export const LIST = `${ROOT}/getJobOfferPage`;
export const RESULT = `${ROOT}/interview`
export const EXPORT = `${ROOT}/export`;
export const JORESULT = `${ROOT}/joboffer`;
export const GET_HOLIDAY_DATES = `${ROOT}/getholidaydates`;
export const JO_APPROVAL_STATUS =`${ROOT}/jobapprovalstatus`;
export const JOB_OFFER_STATUS = `${ROOT}/jobofferstatus`
export const GET_JOB_OFFER_DETAIL_EMAIL_PREVIEW = `${EMAILPREVIEWROOT}/getjobofferdetailemail`;
export const UPDATE_JOB_OFFER_DETAIL_WITH_EMAIL = `${ROOT}/updatejobofferdetailwithemail`;